import "./startgame.css";
import ExitButton from "../../components/exitbutton/exitbutton";
import parse from "html-react-parser";

function StartGameScreen({ setStart, rules }) {
  return (
    <div className="start-game-container">
      <ExitButton />
      <div className="start-game-screen" id="start-game-screen">
        <div className="congratulations">How to play</div>
        <div className="desc">{parse(rules)}</div>

        <div
          className="next-task"
          onClick={() => {
            document
              .getElementById("start-game-screen")
              .classList.add("fade-out");
            setTimeout(() => {
              setStart();
            }, 1000);
          }}
        >
          Play now
        </div>
      </div>
    </div>
  );
}

export default StartGameScreen;
